module.exports = __webpack_public_path__ + "img/Group 4077.54733575.png";